import React, {Component} from 'react';
import ReactEcharts from 'echarts-for-react';
import I18n from 'lib/i18n/i18n';
import SubsetItem from './subsetItem';

class SubsetsList extends Component {

    itemsKeysSortedByPrice(priceData){
        const sortablePriceData = [];
        for (let data in priceData) {
            sortablePriceData.push([data, priceData[data][2]]);
        }
        return sortablePriceData.sort((item1, item2) => item2[1] - item1[1]).map(arr => arr[0]);
    }

    render() {
        const {brand, estRange, subsetValues}= this.props;
        const subsets = {
            'Center Stone': 'centerStone', 'Ring': 'settings', 'Minor Stone Batch': 'smallDiamonds', 'Side Stone Batch' : 'smallDiamonds', ...(brand&&{'Brand':'brand'})
        };
        const brand_images = {
            'bvlgari': 'bvlgari', 'cartier': 'cartier', 'david_yurman': 'david-yurman', 'harry_winston': 'harry', 'tiffany_co': 'tiffany', 'van_cleef_arpels': 'van-cleef'
        };

        const subsetKeys = this.itemsKeysSortedByPrice(this.props.priceData);
        let sumNowSubsets = subsetKeys.filter(k => k != "Center Stone").reduce((total, obj) => this.props.subsetValues[obj] + total, 0)

        const height = subsetKeys.reduce((total, obj) => this.props.priceData[obj][0] + total,0)
        const subsetsComponents = subsetKeys.map((subsetName, i) =>{
            const isLastItem = i === subsetKeys.length -1
            const isPreLastItem = i === subsetKeys.length -2
            const lastItem = isLastItem || isPreLastItem && brand && !(brand in brand_images);
            return <SubsetItem key={i} subsetName={subsets[subsetName]} sumNowSubsets={sumNowSubsets} subsetValue={subsetValues[subsetName]} estRange={estRange} data={this.props.priceData[subsetName]} brand_images={brand_images} brand={brand} lastItem={lastItem} height={height} />
        })

        return(
            <div className="graph subsets" id={`graph${this.props.id}`}>
                <h5>
                    {I18n.getString('itemPage::trends::subsets::startTitle')}
                    <span>${`${estRange.low.toLocaleString('en')} - \$${estRange.high.toLocaleString('en')}`}</span>
                    {I18n.getString('itemPage::trends::subsets::endTitle')}
                </h5>
                { subsetsComponents }
            </div>
        )
    }
}

export default SubsetsList;
